module.exports = __webpack_public_path__ + "static/media/audio.8f1e094f.svg";